import { apiClient } from "./apiClient";
import { unwrapApiResponse } from "../shared/utils/apiResponse";

export type ImportPreviewResult = {
  previewToken?: string;
  rows?: unknown[];
  errors?: unknown[];
  totalRows?: number;
  validRows?: number;
  invalidRows?: number;
};

export async function previewImport(module: string, file: File) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await apiClient.post(`/import/${module}/preview`, form, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return unwrapApiResponse<ImportPreviewResult>(data);
}

export async function confirmImport(module: string, previewToken: string) {
  const { data } = await apiClient.post(`/import/${module}/confirm`, { previewToken });
  return unwrapApiResponse(data);
}

export function getTemplateUrl(module: string) {
  return `/api/import/template/${encodeURIComponent(module)}`;
}
